export default "__VITE_ASSET__Ce9V4Pc4__"